import { useState } from 'react';
import { Link } from 'react-router-dom';

const options = [
  { id: 'A', icon: 'ri-shield-check-line', text: '我想了解自己目前保障是否足夠', color: '#D4A373', path: '/about#health-check-form' },
  { id: 'B', icon: 'ri-home-heart-line', text: '我想為家人規劃醫療保障', color: '#5C5470', path: '/services' },
  { id: 'C', icon: 'ri-time-line', text: '我擔心長期照護費用', color: '#FF8C69', path: '/services' },
  { id: 'D', icon: 'ri-bar-chart-grouped-line', text: '我想做退休與資產防護規劃', color: '#5C5470', path: '/services' },
  { id: 'E', icon: 'ri-building-4-line', text: '我是企業主，想了解團體保險', color: '#D4A373', path: '/services' },
];

const recommendations: Record<string, { title: string; desc: string; link: string; linkLabel: string }> = {
  A: {
    title: '建議從保單健檢開始',
    desc: '先整理現有保單，找出保障缺口，再決定是否需要調整。這是最有效率的起點。',
    link: '/about#health-check-form',
    linkLabel: '下載保單健檢表',
  },
  B: {
    title: '建議了解家庭保障規劃',
    desc: '家庭保障需要考量每位成員的角色與需求，建議先做家庭風險盤點，再進行規劃。',
    link: '/services',
    linkLabel: '了解家庭保障服務',
  },
  C: {
    title: '建議提前了解長照規劃',
    desc: '長期照護費用龐大，越早規劃越有選擇空間。可先用試算工具估算缺口，再與顧問討論。',
    link: '/services',
    linkLabel: '了解長照規劃服務',
  },
  D: {
    title: '建議進行資產配置檢視',
    desc: '退休規劃需要整合保險、儲蓄與投資，建議先下載資產配置檢核表，釐清現況後再規劃。',
    link: '/services',
    linkLabel: '了解退休規劃服務',
  },
  E: {
    title: '建議了解企業團體方案',
    desc: '企業保障方案能提升員工安心感與留才力，建議直接與琮恩討論最適合貴公司的方案。',
    link: '/contact',
    linkLabel: '聯絡我們',
  },
};

export default function ToolsRecommend() {
  const [selected, setSelected] = useState<string | null>(null);
  const [showResult, setShowResult] = useState(false);

  const handleAnalyze = () => {
    if (selected) setShowResult(true);
  };

  const rec = selected ? recommendations[selected] : null;

  return (
    <section className="bg-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <p className="text-[#D4A373] font-semibold tracking-widest mb-3" style={{ fontSize: '1rem' }}>
              SMART ANALYSIS
            </p>
            <h2
              className="font-serif font-bold text-[#5C5470]"
              style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)', lineHeight: '1.4' }}
            >
              不知道從哪裡開始？
              <br />
              先做簡易需求分析
            </h2>
            <div className="w-14 h-1 bg-[#D4A373] mx-auto rounded-full mt-4 mb-4"></div>
            <p className="text-gray-600" style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}>
              選擇最符合您目前狀況的選項，我們為您推薦最適合的起點
            </p>
          </div>

          {/* Options */}
          <div className="space-y-4 mb-10">
            {options.map((opt) => (
              <button
                key={opt.id}
                onClick={() => { setSelected(opt.id); setShowResult(false); }}
                className={`w-full flex items-center gap-4 p-5 rounded-2xl border-2 text-left transition-all duration-200 cursor-pointer
                  ${selected === opt.id
                    ? 'border-[#D4A373] bg-[#D4A373]/8'
                    : 'border-gray-200 bg-[#F8F5F0] hover:border-[#D4A373]/50'
                  }`}
              >
                <div
                  className="w-11 h-11 flex items-center justify-center rounded-xl flex-shrink-0"
                  style={{ backgroundColor: `${opt.color}18` }}
                >
                  <i className={`${opt.icon} text-xl`} style={{ color: opt.color }}></i>
                </div>
                <span
                  className="font-medium text-[#5C5470] flex-1"
                  style={{ fontSize: '1.1875rem', lineHeight: '1.5' }}
                >
                  {opt.text}
                </span>
                {selected === opt.id && (
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#D4A373] flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                )}
              </button>
            ))}
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-10">
            <button
              onClick={handleAnalyze}
              disabled={!selected}
              className={`flex-1 py-4 rounded-full font-semibold whitespace-nowrap transition-all duration-200
                ${selected
                  ? 'bg-[#D4A373] text-white hover:bg-[#c4935f] hover:scale-[1.02] cursor-pointer'
                  : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                }`}
              style={{ fontSize: '1.1875rem' }}
            >
              <i className="ri-search-line mr-2"></i>
              開始分析
            </button>
            <a
              href="https://lin.ee/6XFYSq2"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="flex-1 inline-flex items-center justify-center gap-2 border-2 border-[#5C5470] text-[#5C5470] py-4 rounded-full font-semibold whitespace-nowrap hover:bg-[#5C5470] hover:text-white transition-all duration-200"
              style={{ fontSize: '1.1875rem' }}
            >
              <i className="ri-line-fill"></i>
              加入 LINE 諮詢
            </a>
          </div>

          {/* Result */}
          {showResult && rec && (
            <div className="bg-[#F8F5F0] border border-[#D4A373]/30 rounded-3xl p-8 animate-fade-in">
              <div className="flex items-start gap-4 mb-5">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#D4A373] flex-shrink-0">
                  <i className="ri-lightbulb-line text-white text-lg"></i>
                </div>
                <div>
                  <h3
                    className="font-serif font-bold text-[#5C5470] mb-2"
                    style={{ fontSize: 'clamp(1.125rem, 1.5vw, 1.375rem)', lineHeight: '1.45' }}
                  >
                    {rec.title}
                  </h3>
                  <p className="text-gray-600" style={{ fontSize: '1.0625rem', lineHeight: '1.75' }}>
                    {rec.desc}
                  </p>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-3">
                <Link
                  to={rec.link}
                  className="inline-flex items-center justify-center gap-2 bg-[#5C5470] text-white px-6 py-3.5 rounded-full font-semibold whitespace-nowrap hover:bg-[#4a4360] transition-all duration-200"
                  style={{ fontSize: '1.0625rem' }}
                >
                  {rec.linkLabel}
                  <i className="ri-arrow-right-line"></i>
                </Link>
                <Link
                  to="/contact"
                  className="inline-flex items-center justify-center gap-2 border-2 border-[#5C5470] text-[#5C5470] px-6 py-3.5 rounded-full font-semibold whitespace-nowrap hover:bg-[#5C5470] hover:text-white transition-all duration-200"
                  style={{ fontSize: '1.0625rem' }}
                >
                  預約一對一諮詢
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
